import { MatIconModule } from "@angular/material/icon";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomSnackBarComponent } from "./custom-snack-bar.component";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@NgModule({
  declarations: [CustomSnackBarComponent],
  imports: [CommonModule, MatIconModule, FlexLayoutModule, MatProgressBarModule],
  exports: [CustomSnackBarComponent],
})
export class CustomSnackBarModule {}
